import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const ArrestType = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Arrest Type</InputLabel>
      <Select
        value={moduleValues?.['Arrest Type'] ?? ''}
        label="Arrest Type"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Arrest Type']: e.target.value,
          }))
        }
      >
        {['Witnessed', 'Unwitnessed'].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default ArrestType
